import { gql, useQuery } from '@apollo/client'

import { makeViewModel } from '@/core/architecture'

import { useRouter } from '../router'
import { useSettingMyFavoriteModal } from './useSettingMyFavoriteModal'

type State = {
  artistId: string
  isRequiredFavoriteMember: boolean
}

type Action = Record<string, never>

type RequiredFavoriteMemberQuery = {
  user: {
    id: string
    organizationPatrons: {
      id: string
      artistId: string
      requiredFavoriteMember: boolean
    }[]
  }
}

export const useMyFavoriteViewModel = makeViewModel<State, Action>(() => {
  const { data } = useQuery<RequiredFavoriteMemberQuery>(QUERY)
  const user = data?.user
  const { routerPages, router, location } = useRouter()
  const { isOpen } = useSettingMyFavoriteModal()

  const isRequiredFavoriteMember = (
    user?: RequiredFavoriteMemberQuery['user'] | null
  ): { artistId: string; requiredFavoriteMember: boolean } => {
    if (!user) return { artistId: '', requiredFavoriteMember: false }
    const found = user.organizationPatrons.find(
      patron => patron.requiredFavoriteMember
    )
    return found ?? { artistId: '', requiredFavoriteMember: false }
  }

  return {
    state: {
      artistId: isRequiredFavoriteMember(user).artistId,
      isRequiredFavoriteMember:
        isRequiredFavoriteMember(user).requiredFavoriteMember,
    },
    actions: {},
  }
})

const QUERY = gql`
  query requiredFavoriteMember {
    user {
      id
      organizationPatrons {
        id
        artistId
        requiredFavoriteMember
      }
    }
  }
`
